import { useNavigate } from "react-router-dom";
import { 
  Crown, 
  XCircle,
  ArrowLeft,
  RefreshCw
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import PublicNavbar from "../components/PublicNavbar";

const BACKGROUND_IMAGE = "https://customer-assets.emergentagent.com/job_e54d5963-4f37-44ed-8ca3-11e6a6219384/artifacts/4zfnbqje_IMG_3607.png";

const MembershipCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: '#0a0500' }}>
      {/* Background */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${BACKGROUND_IMAGE})`, opacity: 0.4 }}
      />
      <div 
        className="fixed inset-0"
        style={{ background: 'radial-gradient(ellipse 80% 70% at 50% 40%, transparent 0%, rgba(0,0,0,0.5) 70%, rgba(0,0,0,0.8) 100%)' }}
      />

      <PublicNavbar />

      <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20">
        <Card 
          className="max-w-lg w-full"
          style={{
            background: 'linear-gradient(145deg, rgba(20, 15, 5, 0.95) 0%, rgba(15, 10, 5, 0.95) 100%)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 215, 0, 0.3)',
            boxShadow: '0 0 50px rgba(255, 215, 0, 0.15)'
          }}
          data-testid="membership-cancel-card"
        >
          <CardHeader className="text-center pb-4">
            {/* Cancel Icon */}
            <div className="relative w-20 h-20 mx-auto mb-4">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#EF4444] to-[#DC2626] opacity-30" />
              <div className="absolute inset-2 rounded-full bg-[#0a0500] flex items-center justify-center">
                <XCircle size={40} className="text-[#EF4444]" />
              </div>
            </div>

            <Badge className="bg-[#EF4444]/20 text-[#EF4444] mb-4 px-4 py-1">
              PAYMENT CANCELLED
            </Badge>

            <CardTitle 
              className="text-2xl md:text-3xl mb-2"
              style={{
                background: 'linear-gradient(180deg, #FFFFFF 0%, #E5C558 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              No Worries!
            </CardTitle>
            <p className="text-[#E5C558]">
              Your payment was cancelled. No charges were made.
            </p>
          </CardHeader>

          <CardContent className="space-y-6">
            {/* Info Box */}
            <div 
              className="p-4 rounded-lg text-center"
              style={{ background: 'rgba(26, 26, 26, 0.6)', border: '1px solid rgba(255, 215, 0, 0.1)' }}
            >
              <Crown size={32} className="text-[#FFD700] mx-auto mb-3" />
              <p className="text-[#E5C558] text-sm">
                Ready to unlock exclusive access to DopeInHD's platform? 
                You can try again whenever you're ready.
              </p>
            </div>

            {/* Why Join Section */}
            <div className="space-y-2">
              <h3 className="text-[#FFD700] font-semibold text-center">Why Join?</h3>
              <ul className="text-sm text-[#E5C558] space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-[#22C55E] mt-0.5">•</span>
                  Access to exclusive platform dashboard
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#22C55E] mt-0.5">•</span>
                  Document storage and collaboration tools
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#22C55E] mt-0.5">•</span>
                  Connect with the DopeInHD community
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#22C55E] mt-0.5">•</span>
                  Cancel anytime with no hidden fees
                </li>
              </ul>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
              <Button
                onClick={() => navigate("/membership")}
                className="bg-gradient-to-r from-[#FFD700] to-[#D4AF37] text-[#0a0500] font-semibold"
                data-testid="try-again-btn"
              >
                <RefreshCw className="mr-2" size={18} />
                Try Again
              </Button>
              <Button
                onClick={() => navigate("/")}
                variant="outline"
                className="border-[#FFD700] text-[#FFD700] hover:bg-[#FFD700]/10"
              >
                <ArrowLeft className="mr-2" size={18} />
                Back to Home
              </Button>
            </div>

            {/* Support Note */}
            <p className="text-center text-xs text-[#71717A]">
              Need help? Contact us at support@dopeinhd.com
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MembershipCancel;
